import { useScrollReveal } from '@/hooks/useScrollReveal';

const steps = [
  {
    step: '01',
    icon: 'ri-smartphone-line',
    title: 'Order Online',
    desc: 'Browse our catalogue, pick your cuts, choose your quantities, and place your order — takes under 3 minutes. Select a delivery slot that works for you.',
  },
  {
    step: '02',
    icon: 'ri-inbox-line',
    title: 'Packed & Insulated at Nearest Hub',
    desc: 'Your order is picked from our nearest fulfilment hub, packed in a thermal-insulated box with gel packs, and sealed with a temperature logger inside.',
  },
  {
    step: '03',
    icon: 'ri-motorbike-line',
    title: 'Delivered Within Your City\'s Cold-Chain Window',
    desc: 'Our last-mile partners deliver within a 2-hour window. The temperature logger confirms the cold chain held — if not, we replace your order free.',
  },
];

export default function HowDeliveryWorks() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-widest mb-4">
            How It Works
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-700 mb-4">
            Delivered Cold. Guaranteed.
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto">
            From order to doorstep — every step is designed to protect the cold chain and keep your frozen food at the right temperature.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {steps.map((item) => (
            <div key={item.step} className="group relative text-center bg-card-50 rounded-xl border border-card-200 p-6 shadow-sm hover:shadow-md transition-all">
              {/* Step number */}
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-accent-50 text-accent-600 font-heading text-xl font-bold mx-auto mb-5">
                {item.step}
              </div>

              {/* Icon */}
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 mx-auto mb-4 animate-icon-float icon-hover-pop">
                <i className={`${item.icon} text-lg`}></i>
              </div>

              <h3 className="font-heading text-lg font-bold text-primary-700 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* Policy callout */}
        <div className="mt-12 p-5 md:p-6 bg-accent-50/70 rounded-xl border border-accent-100/50 shadow-sm">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
              <i className="ri-shield-star-line text-lg"></i>
            </div>
            <div>
              <h4 className="font-heading text-base font-bold text-primary-700 mb-1">No-Questions-Asked Replacement Policy</h4>
              <p className="text-sm text-foreground-500 leading-relaxed">
                If the temperature logger inside your delivery box shows the cold chain was compromised at any point, we replace your entire order — no forms, no arguments, no wait. Because frozen food that thawed and refroze isn&apos;t food — it&apos;s a risk.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}